import { render, staticRenderFns } from "./IconSvgSearch.vue?vue&type=template&id=14945196&scoped=true&"
import script from "./IconSvgSearch.vue?vue&type=script&lang=js&"
export * from "./IconSvgSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14945196",
  null
  
)

export default component.exports